import React from 'react'
import cx from 'classnames'
import style from './icon.module.scss'
import PropTypes from 'prop-types'
import IconMap from '../../../resources/assets/icons'
import { VegaIconTypes } from './IconTypes'
import { VegaIconBreakpoint } from './IconConstants'
import { VegaIconLoading } from './loading/IconLoading'
import { VegaIconFlag } from './flag/IconFlag'
import { VegaIconBank } from './bank/IconBank'

const VegaIcon = ({
	className,
	name,
	size = 16,
	type = VegaIconTypes.DEFAULT,
	color,
	background,
	onClick
}) => {
	const isLarge = size > VegaIconBreakpoint

	if (name) {
		const Icon = IconMap[name]

		if (Icon) {
			return (
				<div
					className={cx(style.wrap, {
						[style.clickable]: onClick,
						[style.isLarge]: isLarge
					})}
				>
					<Icon
						className={cx(className, style.icon, type, {
							[style.isLarge]: isLarge
						})}
						width={size}
						height={size}
						style={{ color: color, background: background }}
						onClick={onClick}
					/>
				</div>
			)
		}
	}

	return (
		<VegaIconLoading
			size={size}
			className={cx(className, style.icon, type, { [style.isLarge]: isLarge })}
		/>
	)
}

VegaIcon.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Name of the icon */
	name: PropTypes.string,
	/** Width in px of the icon */
	size: PropTypes.number,
	/** Type of style */
	type: PropTypes.oneOf(Object.values(VegaIconTypes)),
	/** Set color of the icon */
	color: PropTypes.string,
	/** Set background of the icon */
	background: PropTypes.string,
	/** Set action on click */
	onClick: PropTypes.func
}

export { VegaIcon, VegaIconTypes, VegaIconFlag, VegaIconBank }
